<template>
  <div data-component-group="business-form" data-component="settings">
    <slot name="beforeForm" />

    <BusinessSettings :items="settings" :is-loading="isLoading" @change="onChange" />
  </div>
</template>

<script>
  import BusinessSettings from '../../lists/Settings';

  // TODO: Translate component

  export default {
    components: {
      BusinessSettings,
    },
    props: {
      settings: {
        type: Array,
        required: true,
      },
      onSubmit: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        isLoading: false,
      };
    },
    methods: {
      onChange(revert) {
        this.isLoading = true;
        this.onSubmit()
          .catch(() => revert())
          .finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='business-form'][data-component='settings'] {
  padding: $spacing-xl;
  background-color: rgb(var(--v-theme-surface));
  border-top: 1px solid map.get($colors, grey, lighten-2);

  > .component-actions {
    text-align: right;

    .v-btn {
      margin: 0;

      .v-icon {
        margin: 0 6px 0 0;
      }
    }
  }
}
</style>
